module.exports = __webpack_public_path__ + "static/media/CSAyellow.15ac4816.jpg";